/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ModuleWithProviders, NgModule } from '@angular/core';
import {
  CONTEXT_PATH,
  KEYCLOAK_AUTH_SERVER_URL,
  KEYCLOAK_JSON_URL,
  KEYCLOAK_MIN_VALIDITY,
  KEYCLOAK_REALM,
  KEYCLOAK_RESOURCE,
  KEYCLOAK_SECRET,
} from '@gh/config';

import { CoreKeycloakAuthModule, KeycloakConfiguration } from '@gh/core-auth-keycloak';
import { CoreAuthMockModule } from '@gh/core-auth-mock';
import { NoopModule } from '@gh/core-util';

export function logoutOptionsFactory(): KeycloakModule.RedirectUriOptions {
  return {
    redirectUri: window.location.origin + CONTEXT_PATH,
  };
}

export const configuration: KeycloakConfiguration = {
  configuration: KEYCLOAK_JSON_URL ? KEYCLOAK_JSON_URL : {
    url: KEYCLOAK_AUTH_SERVER_URL,
    realm: KEYCLOAK_REALM,
    clientId: KEYCLOAK_RESOURCE,
    credentials: !KEYCLOAK_SECRET ? undefined : {
      secret: KEYCLOAK_SECRET,
    },
  },
  initOptions: {
    onLoad: 'check-sso',
  },
  minValidity: KEYCLOAK_MIN_VALIDITY,
  logoutOptions: logoutOptionsFactory,
};

@NgModule({
  imports: [
    CoreKeycloakAuthModule.asStandalone(configuration),
  ],
})
export class BuilderAuthKeycloakModule {

}

@NgModule({
  imports: [
    CoreKeycloakAuthModule.asDecorated(configuration),
    CoreAuthMockModule.asDecorating(),
  ],
})
export class BuilderAuthKeycloakWithMockModule {

}

@NgModule({
  imports: [
    CoreAuthMockModule.asStandalone({
      fields: ['name', 'email', 'homeView', 'masterZone', 'office'],
      width: 800,
    }),
  ],
})
export class BuilderAuthMockModule {

}

export class BuilderAuthConfigModule {
  static process: any;

  static useKeycloak(): ModuleWithProviders<BuilderAuthConfigModule> {
    return { ngModule: BuilderAuthKeycloakModule };
  }

  static useKeycloakWithMock(): ModuleWithProviders<BuilderAuthConfigModule> {
    return { ngModule: BuilderAuthKeycloakWithMockModule };
  }

  static useMock(): ModuleWithProviders<BuilderAuthConfigModule> {
    return { ngModule: BuilderAuthMockModule };
  }

  static none(): ModuleWithProviders<BuilderAuthConfigModule> {
    return { ngModule: NoopModule };
  }
}
